import React from 'react'
import Typography from '../atoms/Typography'
import { cn } from '../../enviroment/lib/utils'

interface DashboardHeaderProps {
  title: string
  rightSide?: React.ReactNode
  subtitle?: string
  isGradient?: boolean // On Atlas page it overlays map and needs gradient background
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  title,
  subtitle,
  rightSide,
  isGradient: isGradient = false,
}) => {
  return (
    <div
      className={cn(
        'flex w-full items-center justify-between border-b border-b-gray-600 px-7 py-5 text-gray-50',
        ...(isGradient ? ['bg-[linear-gradient(0deg,rgba(0,0,0,0.6)0%,rgba(0,0,0,1)100%)]'] : ['bg-gray-900']),
      )}
    >
      <div>
        <Typography variant="lg-bold">{title}</Typography>

        {subtitle && <Typography variant="sm">{subtitle}</Typography>}
      </div>
      {rightSide && <div className="ml-4">{rightSide}</div>}
    </div>
  )
}

export default DashboardHeader
